module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoggedIn),
      expression: "!isLoggedIn"
    }],
    on: {
      "setIsLoggedIn": _vm.setIsLoggedIn
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }],
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout-ceiling"
  }, [_c('div', {
    staticClass: "ceiling-left"
  }, [_c('div', {
    staticClass: "app-brand"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "app-info"
  }, [_c('div', {
    staticClass: "app-tags"
  }, [_c('span', {
    staticClass: "tag tag-name"
  }, [_vm._v("\n                    " + _vm._s(_vm.appName) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "tag tag-version"
  }, [_vm._v("\n                    v" + _vm._s(_vm.appVersion) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "tag tag-build"
  }, [_vm._v("\n                    " + _vm._s(_vm.checkAppJSTag()) + "\n                  ")]), _vm._v(" "), (_vm.isDev) ? _c('span', {
    staticClass: "tag tag-dev"
  }, [_vm._v("\n                    DEV\n                  ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ceiling-right"
  }, [_c('div', {
    staticClass: "tab-switch"
  }, [_c('span', [_vm._v("Tab Mode")]), _vm._v(" "), _c('i-switch', {
    attrs: {
      "size": "large",
      "open-color": "#22c55e",
      "close-color": "#ef4444"
    },
    on: {
      "on-change": _vm.onTabChange
    },
    model: {
      value: (_vm.useTab),
      callback: function($$v) {
        _vm.useTab = $$v
      },
      expression: "useTab"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("On")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Off")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-action"
  }, [_c('div', {
    staticClass: "user-box"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-person-circle-outline",
      "size": "22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-text"
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('div', {
    staticClass: "role"
  }, [_vm._v(_vm._s(_vm.user.role))])])], 1), _vm._v(" "), _c('Button', {
    staticClass: "logout-btn",
    attrs: {
      "type": "error",
      "size": "small"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('Icon', {
    attrs: {
      "type": "log-out"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Menu', {
    staticClass: "sidebar-menu",
    attrs: {
      "active-name": "2-1",
      "width": "auto"
    }
  }, [_c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('kontra')),
      expression: "canAccessMenu('kontra')"
    }],
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-filing-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Kontra\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/kontra/create"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "2-1"
    }
  }, [_vm._v("Buat")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/kontra/print"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "2-2"
    }
  }, [_vm._v("Cetak")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/kontra/reprint"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "2-3"
    }
  }, [_vm._v("Cetak\n                                Ulang")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('piutang')),
      expression: "canAccessMenu('piutang')"
    }],
    attrs: {
      "name": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-paper-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Piutang\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/invoice/invoiceUnSettled"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-1"
    }
  }, [_vm._v("Jatuh\n                                Tempo")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/receivable/list/cut-off"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-2"
    }
  }, [_vm._v("Kartu\n                                Piutang")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/receivable/list"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-3"
    }
  }, [_vm._v("Kartu Piutang\n                                History")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('pembayaran-delete')),
      expression: "canAccessMenu('pembayaran-delete')"
    }],
    attrs: {
      "to": "/receivable/delete"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-4"
    }
  }, [_vm._v("Hapus Piutang")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('pembayaran-delete')),
      expression: "canAccessMenu('pembayaran-delete')"
    }],
    attrs: {
      "to": "/invoice/delete"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-5"
    }
  }, [_vm._v("Hapus Invoice")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/invoice/failedInvoicing"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-6"
    }
  }, [_vm._v("Failed\n                                Invoicing")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/receivable/receivableAddList"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-7"
    }
  }, [_vm._v("List Piutang\n                                Manual")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/receivable/hotList"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-8"
    }
  }, [_vm._v("Summary Kartu\n                                Piutang")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/receivable/list-detail"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "3-9"
    }
  }, [_vm._v("Kartu Piutang\n                                Detail")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('pembayaran')),
      expression: "canAccessMenu('pembayaran')"
    }],
    attrs: {
      "name": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "social-usd-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Pembayaran\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/receivable/pendingFunds"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-1"
    }
  }, [_vm._v("Tambah")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/payment/paymentPending/list-data/search/" + (Date.now()))
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-2"
    }
  }, [_vm._v("List\n                                Data")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('pembayaran-tambah')),
      expression: "canAccessMenu('pembayaran-tambah')"
    }],
    attrs: {
      "to": "/payment/add"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-3"
    }
  }, [_vm._v("Penyesuaian")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('pembayaran-history')),
      expression: "canAccessMenu('pembayaran-history')"
    }],
    attrs: {
      "to": "/payment/list"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-4"
    }
  }, [_vm._v("Histori")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('potongan-history')),
      expression: "canAccessMenu('potongan-history')"
    }],
    attrs: {
      "to": "/payment/discount-list"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-5"
    }
  }, [_vm._v("Histori\n                                Potongan")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('pembayaran-delete')),
      expression: "canAccessMenu('pembayaran-delete')"
    }],
    attrs: {
      "to": "/payment/delete"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-6"
    }
  }, [_vm._v("Hapus")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('pembayaran-history-delete')),
      expression: "canAccessMenu('pembayaran-history-delete')"
    }],
    attrs: {
      "to": "/payment/history/delete"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-7"
    }
  }, [_vm._v("Histori\n                                Hapus")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/payment/download"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "4-8"
    }
  }, [_vm._v("Download")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('mutasi-nota-transaksi')),
      expression: "canAccessMenu('mutasi-nota-transaksi')"
    }],
    attrs: {
      "name": "5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "social-usd-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Nota Transaksi\n                        ")], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('mutasi-nota-transaksi')),
      expression: "canAccessMenu('mutasi-nota-transaksi')"
    }],
    attrs: {
      "to": "/mutasi/list"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "5-1"
    }
  }, [_vm._v("Mutasi")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('mutasi-nota-transaksi')),
      expression: "canAccessMenu('mutasi-nota-transaksi')"
    }],
    attrs: {
      "to": "/mutasi/list/giro"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "5-2"
    }
  }, [_vm._v("Giro")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('mutasi-nota-transaksi')),
      expression: "canAccessMenu('mutasi-nota-transaksi')"
    }],
    attrs: {
      "to": "/mutasi/list/adjustment"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "5-3"
    }
  }, [_vm._v("Penyesuaian")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('mutasi-nota-transaksi')),
      expression: "canAccessMenu('mutasi-nota-transaksi')"
    }],
    attrs: {
      "to": "/fix-note"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "5-4"
    }
  }, [_vm._v("Penyesuaian Nomor Nota Transaksi")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('claim')),
      expression: "canAccessMenu('claim')"
    }],
    attrs: {
      "name": "7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-checkmark-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Klaim\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/claim/add"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "7-1"
    }
  }, [_vm._v("Tambah")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/claim/list"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "7-2"
    }
  }, [_vm._v("List")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/claim/download"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "7-3"
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/claim/transaction-note"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "7-4"
    }
  }, [_vm._v("Nota\n                                Transaksi")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('giro')),
      expression: "canAccessMenu('giro')"
    }],
    attrs: {
      "name": "8"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    staticStyle: {
      "margin-right": "13px"
    },
    attrs: {
      "type": "ios-copy-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Giro\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/giro/list"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "8-1"
    }
  }, [_vm._v("List")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/giro/pending"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "8-2"
    }
  }, [_vm._v("Pending")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/giro/calendar"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "8-3"
    }
  }, [_vm._v("Kalender")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/giro/dueDate"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "8-4"
    }
  }, [_vm._v("Jatuh Tempo")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/giro/cancelled-history"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "8-5"
    }
  }, [_vm._v("Histori\n                                Pembatalan")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/giro/transaction-note"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "8-6"
    }
  }, [_vm._v("Nota\n                                Transaksi")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('deposit')),
      expression: "canAccessMenu('deposit')"
    }],
    attrs: {
      "name": "9"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-checkmark-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Deposit\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/deposit-adjustment"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "9-1"
    }
  }, [_vm._v("Penyesuaian & Mutasi")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/deposit/withdrawal-history"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "9-3"
    }
  }, [_vm._v("Histori\n                                Penarikan")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "10"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-list-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Master\n                        ")], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('master')),
      expression: "canAccessMenu('master')"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/master/user"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-1"
    }
  }, [_vm._v("User")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/master/itemDept"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-2"
    }
  }, [_vm._v("Item Dept")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/master/bankAccount"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-3"
    }
  }, [_vm._v("Bank Account")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/master/bankAccountGroup"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-5"
    }
  }, [_vm._v("Bank Account Group")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/master/Division"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-6"
    }
  }, [_vm._v("Division")])], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('master.marking-top')),
      expression: "canAccessMenu('master.marking-top')"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/master/marking-top"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-7"
    }
  }, [_vm._v("Marking TOP")])], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('master.marking-group')),
      expression: "canAccessMenu('master.marking-group')"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": "/master/markingGroup"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-8"
    }
  }, [_vm._v("Marking Group")])], 1)], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/master/coa"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "9-5"
    }
  }, [_vm._v("Chart of Account (COA)")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('sms')),
      expression: "canAccessMenu('sms')"
    }],
    attrs: {
      "name": "11"
    }
  }, [_vm._v(">\n                        "), _c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-email-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            SMS\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/sms/log"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "10-2"
    }
  }, [_vm._v("Log")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('administrator')),
      expression: "canAccessMenu('administrator')"
    }],
    attrs: {
      "name": "12"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "printer",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Administrator\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/administrator/kontra/isprint"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "12-1"
    }
  }, [_vm._v("Kontra Print\n                                Status")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/administrator/receivable/delete"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "12-2"
    }
  }, [_vm._v("Hapus\n                                Piutang")])], 1)], 2), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('suratjalan')),
      expression: "canAccessMenu('suratjalan')"
    }],
    attrs: {
      "name": "13"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-printer-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Surat Jalan\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/surat/suratjalan"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "13-1"
    }
  }, [_vm._v("Surat Jalan")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/surat/suratjalanbelumprint"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "13-2"
    }
  }, [_vm._v("Surat Jalan Belum Di Print")])], 1)], 2), _vm._v(" "), _c('router-link', {
    staticClass: "menu-parents",
    attrs: {
      "to": "/settings"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "14"
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-right": "13px"
    },
    attrs: {
      "type": "ios-gear-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("Setting\n                        ")], 1)], 1), _vm._v(" "), _c('Submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAccessMenu('administrator')),
      expression: "canAccessMenu('administrator')"
    }],
    attrs: {
      "name": "15"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Logs\n                        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/logs/erp/journal-pooling"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "15-1"
    }
  }, [_vm._v("ERP Journal\n                                Pooling")])], 1)], 2), _vm._v(" "), _c('router-link', {
    staticClass: "menu-parents",
    attrs: {
      "to": "/omset/list"
    }
  }, [_c('Menu-item', {
    attrs: {
      "name": "16"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "arrow-graph-up-right",
      "size": _vm.iconSize
    }
  }), _vm._v("\n                            Omset\n                        ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_c('Back-top'), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-content-main"
  }, [(_vm.useTab) ? [_c('Tabs', {
    staticClass: "tabs-custom",
    staticStyle: {
      "background-color": "#fff",
      "padding": "5px 2px"
    },
    attrs: {
      "value": _vm.activeTab,
      "type": "card",
      "closable": "",
      "scrollable": ""
    },
    on: {
      "on-click": _vm.onTabClick,
      "on-tab-remove": _vm.onTabRemove
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('TabPane', {
      key: tab.path,
      attrs: {
        "label": tab.title,
        "name": tab.path,
        "closable": tab.path !== '/'
      }
    })
  }), 1), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)] : [_c('router-view')]], 2)])], 1)], 1)], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Apa yang Baru?",
      "width": "800"
    },
    model: {
      value: (_vm.showWhatsNew),
      callback: function($$v) {
        _vm.showWhatsNew = $$v
      },
      expression: "showWhatsNew"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('h3', [_vm._v("Fitur Tab Mode")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto",
      "border-radius": "5px"
    },
    attrs: {
      "src": require('@/assets/images/tabmode.png'),
      "alt": "Tab Mode"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                Dengan fitur Tab Mode, Anda dapat membuka beberapa halaman dalam satu jendela. Cukup klik tab yang diinginkan untuk beralih antar halaman.\n                Anda juga dapat menutup tab yang sudah tidak diperlukan.\n\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                Untuk mencoba fitur ini, klik Tab Mode di pojok kanan layar, lalu pilih On.\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.closeWhatsNew
    }
  }, [_vm._v("Tutup")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.dontShowWhatsNewAgain
    }
  }, [_vm._v("Jangan tampilkan lagi")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    staticClass: "app-logo",
    attrs: {
      "src": "/static/login-logo-r1.png",
      "alt": "Logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d73755a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1854
// module chunks = 1